import { render, staticRenderFns } from "./ActiveGame.vue?vue&type=template&id=c7091e60&"
import script from "./ActiveGame.vue?vue&type=script&lang=js&"
export * from "./ActiveGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports